import React from 'react'
import { Element } from 'react-bulma-components'

interface TerminalExplanationProps {
  textColor?: string
}

const TerminalExplanation: React.FC<TerminalExplanationProps> = ({ textColor }) => {
  return (
    <>
      <Element mb={2}>
        Les bornes de pointage sont des dispositifs physiques installés sur vos sites qui permettent
        aux intérimaires d'enregistrer leurs heures de travail. Chaque borne dispose de plusieurs
        fonctionnalités :
      </Element>

      <Element mb={3}>
        <Element renderAs="strong" textColor={textColor}>
          Pointage QR Code
        </Element>
        <Element>
          Les intérimaires peuvent pointer leur arrivée et leur départ en scannant leur QR code
          personnel. Le système vérifie automatiquement que l'intérimaire est bien affecté à une
          mission sur le site.
        </Element>
      </Element>

      {/*<Element mb={3}>
        <Element renderAs="strong" textColor={textColor}>
          Mode Hors-Ligne
        </Element>
        <Element>
          Les bornes continuent de fonctionner même en cas de coupure internet. Les pointages sont
          stockés localement puis synchronisés automatiquement dès que la connexion est rétablie.
        </Element>
      </Element>

      <Element mb={3}>
        <Element renderAs="strong" textColor={textColor}>
          Suivi en Temps Réel
        </Element>
        <Element>
          L'état de chaque borne (en ligne/hors ligne) est surveillé en permanence. En cas de
          dysfonctionnement, une alerte est automatiquement envoyée à l'équipe technique.
        </Element>
      </Element>*/}

      <Element>
        <Element renderAs="i" textSize={7}>
          L'installation et la maintenance des bornes sont assurées par l'équipe technique TeamTim.
          Pour toute demande, contactez votre administrateur.
        </Element>
      </Element>
    </>
  )
}

export default TerminalExplanation
